import React, { useState } from 'react'

import { Col, Row } from 'react-bootstrap'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import Form from 'Components/Form'
import { Input } from 'Components/Form/Input'
import SubmitButton from 'Components/Form/SubmitButton'
import Button from 'Components/Form/Button'
import { Checkbox } from 'Components/Form/Checkbox'
import { Dropzone } from 'Components/Form'
import SelectMultiple from 'Components/Form/SelectMultiple'
import { CLIENT_FORM_MODES } from '../const'
import {
  required,
  string,
  maxValue,
  minValue,
} from 'Utils/Validators/formValidation'
import { styles } from './styles'

const ClientForm = ({
  classes,
  defaultValues,
  mode,
  handleCancel,
  handleSubmit,
  buttonsDisabled,
  tags,
}) => {
  const [file, setFile] = useState(null)
  let initValues = {
    name: '',
    code: '',
    status: false,
    tags: [],
    logo: '',
  }

  if (mode === CLIENT_FORM_MODES.EDIT) {
    initValues = {
      name: defaultValues.name,
      code: defaultValues.code,
      status: defaultValues.status === 'DELETED',
      tags: defaultValues.tags,
      logo: defaultValues.logo,
    }
  }

  return (
    <Form onSubmit={(form, isValid) => handleSubmit(form, isValid, file)}>
      <Typography className={classes.title} variant="h4">
        {mode === CLIENT_FORM_MODES.ADD ? 'Add Client' : 'Edit Client'}
      </Typography>
      <Card className={classes.card}>
        <Row>
          <Col xs={6}>
            <Input
              label="Name"
              name="name"
              placeholder="E.g Uber"
              validator={[required]}
              initValue={initValues.name}
            />
            <Input
              className={classes.input}
              label="Client Reference"
              name="code"
              validator={[required, minValue(3), maxValue(6), string]}
              initValue={initValues.code}
            />
            {mode === CLIENT_FORM_MODES.EDIT ? (
              <Checkbox
                label="Archived"
                name="status"
                initValue={initValues.status}
              />
            ) : null}
            <SelectMultiple
              name="tags"
              options={tags}
              initValue={initValues.tags}
            />
          </Col>
          <Col xs={6} className={classes.dropzone}>
            <Dropzone
              name="logo"
              input={{
                value: initValues.logo,
                onChange: files => setFile(files[0]),
              }}
              meta={{}}
            />
          </Col>
        </Row>
      </Card>
      <div className={classes.buttonsWrapper}>
        <Button variant="outlined" value="Cancel" onClick={handleCancel} />
        <SubmitButton
          disabled={buttonsDisabled}
          variant="contained"
          value="Submit"
        />
      </div>
    </Form>
  )
}

export default withStyles(styles)(ClientForm)



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientForm/index.js